(function () {
  // Slugify a color option value so it can be matched against image URLs.
  function slug(v) {
    return v.toLowerCase().trim().replace(/\s+/g, "-");
  }

  // Slugs of all color options, longest first so "military-green" matches before "green".
  function allSlugs() {
    var r = [];
    document.querySelectorAll('variant-picker input[data-option-name="Color"]').forEach(function (e) {
      if (e.value) r.push(slug(e.value));
    });
    r.sort(function (x, y) { return y.length - x.length; });
    return r;
  }

  // Slug of the currently selected color.
  function currentSlug() {
    var e = document.querySelector('variant-picker input[data-option-name="Color"]:checked');
    return e && e.value ? slug(e.value) : "";
  }

  // Find the color slug contained in an image URL (longest match wins).
  function matchSlug(src, slugs) {
    src = src.toLowerCase();
    for (var i = 0; i < slugs.length; i++) {
      if (src.indexOf(slugs[i]) > -1) return slugs[i];
    }
    return "";
  }

  // Show only the gallery media belonging to the selected color.
  function filterGallery() {
    var v = currentSlug();
    if (!v) return;
    var slugs = allSlugs();
    var imgs = document.querySelectorAll("media-gallery img.product-media__image");
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.currentSrc || img.src || "";
      var found = matchSlug(src, slugs);
      var show = found === v;
      var cont = img.closest(".product-media-container") || img.parentElement;
      if (cont) cont.style.display = show ? "" : "none";
    }
  }

  // Debounce re-filtering (~100ms) so the gallery re-render doesn't trigger excessive runs.
  var debounceTimer = null;
  function scheduleFilter() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      filterGallery();
    }, 100);
  }

  // Watch the media gallery: the theme re-renders it after variant changes, which
  // wipes out previous filter state. Re-apply the filter whenever the gallery DOM changes.
  var observer = null;
  function startObserving() {
    var gallery = document.querySelector("media-gallery");
    // Observe the gallery's parent rather than the gallery itself: the theme
    // replaces the whole media-gallery element on variant change, which would
    // orphan an observer attached to the detached element.
    var target = (gallery && gallery.parentElement) || document.body;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      scheduleFilter();
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function init() {
    filterGallery();
    startObserving();
  }

  document.addEventListener("DOMContentLoaded", init);
})();